import axios from "axios";
import {appConfig} from "../config/defaultConfig";

const IROH_SERVICES = appConfig.APP.IROH_SERVICES;
const DEFAULT_PAGE_SIZE = 500;
const DEFAULT_SEARCH_SORT_BY = "user-name";
const DEFAULT_SEARCH_ORDER = "asc";

const fetchUsers = async (
  fetchLimit,
  sortBy = DEFAULT_SEARCH_SORT_BY,
  sortOrder = DEFAULT_SEARCH_ORDER,
  searchValue
) => {
  let results = [];
  let total = Infinity;
  let numberFetched = 0;
  const q = new URLSearchParams();
  q.append("sort_by", sortBy);
  q.append("sort_order", sortOrder);
  if (searchValue && searchValue.length > 1) {
    q.append("query", searchValue);
  }
  for (let i = 0; numberFetched < total; i + 1) {
    q.set("offset", numberFetched);
    q.set("limit", fetchLimit);
    await axios
      .post(`${IROH_SERVICES.ROUTES.USERS_SEARCH}?${q.toString()}`, {
        "enabled?": true
      })
      .then((response) => {
        total = response.headers["x-total-hits"];
        numberFetched += response.data.length;
        results = results.concat(response.data);
      });
  }
  return results;
};

export const fetchAllUsers = async () => await fetchUsers(DEFAULT_PAGE_SIZE);
